/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.outerwrap[_ngcontent-%COMP%]{height:100%}.actionbar[_ngcontent-%COMP%]{margin-top:15px}.scroll[_ngcontent-%COMP%]{overflow-y:auto}  .mat-checkbox-label{white-space:normal}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/edittestthreshold/edittestthreshold.dialogcomponent.scss.shim.ngstyle.js.pre-build-optimizer.js